import { NEW_INDEX_NAV_SEED } from '@/data/newIndexNav.js';

const MORE_NAMES = {
  zh: '更多',
  zhCHT: '更多',
  en: 'More',
};

function isVisible(item) {
  return item && item.visible !== false;
}

function sortItems(items) {
  return [...items].sort((a, b) => (a.sort ?? 0) - (b.sort ?? 0));
}

function nameText(names, key) {
  const value = names?.[key];
  return typeof value === 'string' ? value.trim() : '';
}

function stripMoreDecor(text) {
  return String(text || '').replace(/\s*[›>]{1,}\s*$/g, '').trim();
}

export function navLabel(item, locale) {
  const names = item?.names || {};
  const label = nameText(names, locale) || nameText(names, 'zh') || nameText(names, 'en');
  return item?.type === 'more' ? stripMoreDecor(label) : label;
}

export function navHref(item) {
  if (!item) return '#';
  if (item.type === 'more') return item.value || item.more_value || '#';
  return item.value || '#';
}

export function isExpandOnly(item) {
  return item?.type === 'route' && !item.value;
}

function withMoreChild(parent) {
  const children = sortItems((parent.children || []).filter(isVisible));
  if (!parent.more_value || !children.length) return children;
  children.push({
    id: `${parent.id}-more`,
    type: 'more',
    value: parent.more_value,
    visible: true,
    sort: 999,
    names: MORE_NAMES,
    target: '_self',
  });
  return children;
}

export function normalizeNavTree(raw, { includeHidden = false, appendMore = false } = {}) {
  const list = Array.isArray(raw) ? raw : [];
  return sortItems(list)
    .filter((item) => includeHidden || isVisible(item))
    .filter((item) => !isExpandOnly(item) || (item.children || []).some(isVisible))
    .map((item) => ({
      ...item,
      children: appendMore
        ? withMoreChild(item)
        : sortItems((item.children || []).filter(isVisible)),
    }));
}

export function parsePortalNav(raw) {
  if (!Array.isArray(raw)) return null;
  return normalizeNavTree(raw);
}

export function getNewIndexNavSeed() {
  return normalizeNavTree(NEW_INDEX_NAV_SEED, { appendMore: true });
}

export function resolveNavLocale(locale) {
  if (locale === 'zh' || locale === 'zhCHT') return locale;
  return locale || 'en';
}
